import { useContext } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type productsScreen_Query } from "@relay/productsScreen_Query.graphql";
import { ProductsTable } from "./parts/products-table";
import { ProductsTableFilters } from "./parts/products-table-filters/products-table-filters.component";
import { ProductsScreenContext } from "./products.context";
import { QUERY } from "./products.graphql";
import { ProductsContextProvider } from "./products.provider";
import { wrapperClass } from "./products.styles";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { CreateLicenseProductButton } from "../../features/products/create-license-product-button";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const ProductsScreen = () => {
	const { t } = useTranslation("common");
	const { filters } = useContext(ProductsScreenContext);

	const query = useLazyLoadQuery<productsScreen_Query>(
		QUERY,
		{
			...filters,
		},
		{ fetchPolicy: "network-only" },
	);

	const canRead = useHasPermissions(["UserInAccountPermission_ProductAdmin_Read"]);
	const canModify = useHasPermissions(["UserInAccountPermission_ProductAdmin_Modify"]);

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("products.title")}>
			<ProductsContextProvider>
				<ProductsTableFilters />
				{canModify && (
					<div className={wrapperClass}>
						<CreateLicenseProductButton className="ml-2 align-self-end" />
					</div>
				)}
				<ProductsTable productsQueryFragment={query} />
			</ProductsContextProvider>
		</BaseScreen>
	);
};
